// import values from 'lodash/values';
// import find from 'lodash/find';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Bangkok');


export const sortByCities = (a, b) => {
  if (a.city === 'Bangkok') return -1;
  if (a.city < b.city) return -1;
  if (a.city > b.city) return 1;
  return 0;
};

export const convertToDestinationArray = data => {
  let destinations = [];
  Object.keys(data).map(key => (destinations = destinations.concat(data[key]))); //eslint-disable-line
  return destinations;
};

export const groupDestinationsByKey = key => props => {
  const { messages } = props;
  const popular = props.destinations.filter(d => d.popular);
  const cities = props.destinations
    .filter(d => !d.popular)
    .reduce((prev, cur) => {
      if (!prev[cur[key]]) {
        prev[cur[key]] = []; // eslint-disable-line
      }
      prev[cur[key]].push(cur);
      return prev;
    }, {});
  popular.sort(sortByCities);
  Object.keys(cities).map(k => cities[k].sort(sortByCities));
  const grouped = popular.length > 0
    ? { [messages.popular_cities]: popular }
    : {};
  return { ...grouped, ...cities };
};

export const groupDestinationsByRegion = groupDestinationsByKey('region');
export const groupDestinationsByCountry = groupDestinationsByKey('country');

/* eslint-disable */
export function getMeetingPoints(meetingPoints = []) {
  return Object.values(
    meetingPoints.reduce((prev, cur) => {
      if (prev[cur.icon_name]) {
        prev[cur.icon_name].text += `, ${cur.name}`; // eslint-disable-line
      } else {
        prev[cur.icon_name] = {
          // eslint-disable-line
          data: cur,
          type: cur.type,
          icon_name: cur.icon_name,
          text: cur.name,
        };
      }
      return prev;
    }, {})
  );
}
/* eslint-enable */

// export function getHour(hour) {
//   if (hour && hour.split(' ')) {
//     return hour.split(' ')[0];
//   }
//   return null;
// }

// export function hasBorder(i, l) {
//   if (l % 3 === 0) {
//     return i < l - 3;
//   }
//   return i < l - l % 3; // eslint-disable-line
// }

// export function getTransportation(trans) {
//   switch (trans) {
//     case 'Private Car':
//       return { standard: true, id: 'trip.item.private_car', type: 'private_car' };
//     case 'Private Motorcycle':
//       return { standard: true, id: 'trip.item.private_motorcycle', type: 'private_motorcycle' };
//     case 'Private Van':
//       return { standard: true, id: 'trip.item.private_van', type: 'private_van' };
//     case 'Private Jetski':
//       return { standard: true, id: 'trip.item.private_jet_ski', type: 'private_jet_ski' };
//     case 'Private Bicycle':
//       return { standard: true, id: 'trip.item.private_bike', type: 'private_bike' };
//     case 'Private ATV':
//       return { standard: true, id: 'trip.item.private_atv', type: 'private_atv' };
//     case 'Public Transportation':
//       return { standard: true, id: 'trip.item.public_transportation' };
//     default:
//       return { standard: false, id: trans, type: 'other' };
//   }
// }

/* eslint-disable */
// export function getActivityIcon(activity) {
//   if (
//     activity === 'Bazaar' ||
//     activity === 'ตลาดนัดถาวร' ||
//     activity === '大集市'
//   ) {
//     return 'bazaar';
//   }
//   if (
//     activity === 'Floating Market' ||
//     activity === 'ตลาดน้ำ' ||
//     activity === '水上市场'
//   ) {
//     return 'floating-market';
//   }
//   if (
//     activity === 'Fresh Market' ||
//     activity === 'ตลาดสด' ||
//     activity === '生鲜市场'
//   ) {
//     return 'fresh-market';
//   }
//   if (
//     activity === 'Flea Market' ||
//     activity === 'ตลาดนัด' ||
//     activity === '平价集市'
//   ) {
//     return 'flea-market';
//   }
//   if (
//     activity === 'Farming'
//   ) {
//     return 'farming';
//   }
//   if (activity === 'Cafe' || activity === 'ร้านกาแฟ' || activity === '咖啡店') {
//     return 'cafe';
//   }
//   if (
//     activity === 'Cooking Class' ||
//     activity === 'เรียนทำอาหาร' ||
//     activity === '烹饪课'
//   ) {
//     return 'cooking-class';
//   }
//   if (
//     activity === 'Restaurants' ||
//     activity === 'ร้านอาหาร' ||
//     activity === '餐厅'
//   ) {
//     return 'restaurants';
//   }
//   if (
//     activity === 'Street Food' ||
//     activity === 'อาหารริมทาง' ||
//     activity === '街边小吃'
//   ) {
//     return 'street-food';
//   }
//   if (activity === 'Adventure' || activity === 'ผจญภัย' || activity === '探险') {
//     return 'adventure';
//   }
//   if (activity === 'Boating' || activity === 'นั่งเรือ' || activity === '划船') {
//     return 'boating';
//   }
//   if (activity === 'Boxing' || activity === 'ต่อยมวย' || activity === '拳击') {
//     return 'boxing';
//   }
//   if (
//     activity === 'City Tour' ||
//     activity === 'ชมเมือง' ||
//     activity === '都市畅游'
//   ) {
//     return 'city-tour';
//   }
//   if (
//     activity === 'Cycling' ||
//     activity === 'ปั่นจักรยาน' ||
//     activity === '自行车骑行'
//   ) {
//     return 'cycling';
//   }
//   if (
//     activity === 'Beach & Island' ||
//     activity === 'ชายหาดและเกาะ' ||
//     activity === '海滩&岛屿'
//   ) {
//     return 'beach-n-island';
//   }
//   if (
//     activity === 'Botanic Garden' ||
//     activity === 'สวน' ||
//     activity === '花园'
//   ) {
//     return 'botanic-garden';
//   }
//   if (
//     activity === 'Safari' ||
//     activity === 'ซาฟารี ส่องสัตว์' ||
//     activity === '野生动物园'
//   ) {
//     return 'safari';
//   }
//   if (
//     activity === 'Trekking & Hiking' ||
//     activity === 'เดินป่าและปีนเขา' ||
//     activity === '徒步旅行'
//   ) {
//     return 'trekking-n-hiking';
//   }
//   if (activity === 'Waterfall' || activity === 'น้ำตก' || activity === '瀑布') {
//     return 'waterfall';
//   }
//   if (
//     activity === 'Water Activities' ||
//     activity === 'กิจกรรมทางน้ำ' ||
//     activity === '水上活动'
//   ) {
//     return 'water-activities';
//   }
//   if (
//     activity === 'Local Wisdom & Living' ||
//     activity === 'ภูมิปัญญาท้องถิ่น' ||
//     activity === '当地生活'
//   ) {
//     return 'local-wisdom-n-living';
//   }
//   if (
//     activity === 'Volunteering' ||
//     activity === 'อาสาสมัคร' ||
//     activity === '志愿者'
//   ) {
//     return 'volunteering';
//   }
//   if (
//     activity === 'Art Exhibition' ||
//     activity === 'การแสดงศิลปะ' ||
//     activity === '艺术展览'
//   ) {
//     return 'art-exhibition';
//   }
//   if (activity === 'Crafting' || activity === 'หัตถกรรม' || activity === '手工') {
//     return 'crafting';
//   }
//   if (
//     activity === 'Drinking' ||
//     activity === 'ท่องราตรี' ||
//     activity === '饮料'
//   ) {
//     return 'drinking';
//   }
//   if (
//     activity === 'History & Culture' ||
//     activity === 'ประวัติศาสตร์และวัฒนธรรม' ||
//     activity === '历史&文化'
//   ) {
//     return 'history-n-culture';
//   }
//   if (
//     activity === 'Massage & Spa' ||
//     activity === 'สปาและการนวด' ||
//     activity === '按摩&SPA'
//   ) {
//     return 'massage-n-spa';
//   }
//   if (
//     activity === 'Spiritual' ||
//     activity === 'จิตวิญญาณ' ||
//     activity === '冥想'
//   ) {
//     return 'spiritual';
//   }
// }

// export function getCondition(condition) {
//   switch (condition) {
//     case 'Smart Casual':
//       return {
//         icon: 'smart-casual',
//       };
//     case 'Physical Strength Required':
//       return {
//         icon: 'physical-strength',
//       };
//     case 'Vegetarian Food Available':
//       return {
//         icon: 'vegeterian-food',
//       };
//     case 'Children Friendly':
//       return {
//         icon: 'children-friendly',
//       };
//     case 'Flexible Plan':
//       return {
//         icon: 'flexible-plan',
//       };
//     case 'Seasonal Activities':
//       return {
//         icon: 'seasonal-activity',
//       };
//     default:
//       return {
//         icon: '',
//       };
//   }
// }
/* eslint-enable */

export function decorateMultiTierPricesToQuantity(multiTierPrices) {
  return multiTierPrices.reduce(
    (acc, curr) => [
      ...acc,
      {
        tier: curr.tier,
        sub_tiers: curr.sub_tiers.map(sub => ({ ...sub, quantity: 0 })),
      },
    ],
    []
  );
}

export function getAddOptObj(selectedOptions = [], currency, key) {
  return selectedOptions.find(item => item.key === key && item.currency === currency)
    || selectedOptions.find(item => item.key === key);
  // return find(selectedOptions, { key, currency }) || find(selectedOptions, { key });
}

export function decorateAdditionalOptionsString(obj) {
  if (Object.keys(obj).length === 0) return '';
  let optionsString = '';
  if (obj.childQuantity > 0) {
    optionsString += `children:${obj.childQuantity}`;
  }
  if (obj.selectedTimeSlotIdx >= 0) {
    optionsString += `time_slot:${obj.selectedTimeSlotIdx}`;
  }
  if (optionsString === '') return '';
  return `options=${optionsString}`;
}

export function showTodayOrTomorrowAvailable(trip) {
  const available = [];
  if (!trip.availabilities) return available;
  const todayDateInAvailable = trip.availabilities.find(a => a.is_tomorrow && a.status === 'available');
  const tomorrowDateInAvailable = trip.availabilities.find(a => a.is_tomorrow && a.status === 'available');
  if (todayDateInAvailable && moment().add(trip.hours_in_advance, 'hour').isBefore(moment(todayDateInAvailable.date).startOf('day'))) {
    available.push('today');
  }
  if (tomorrowDateInAvailable && moment().add(trip.hours_in_advance, 'hour').isBefore(moment(tomorrowDateInAvailable.date).startOf('day'))) {
    available.push('tomorrow');
  }
  return available;
}

export const mapIcon = type => {
  switch (type) {
    case 'airport':
      return 'airplane';
    case 'Art & Craft Workshops':
      return 'picture-frame';
    case 'Child Friendly':
    case 'Children Friendly':
      return 'toy';
    case 'Cooking':
      return 'cooking';
    case 'Fitness & Wellness':
      return 'healthcare';
    case 'Flexible Plan':
      return 'clock-11';
    case 'Food & Drink':
      return 'restaurant';
    case 'Fun & Adventure':
      return 'activity';
    case 'History & Culture':
      return 'pagonda';
    case 'Local Life':
      return 'thai-house';
    case 'Local Ride':
      return 'tuktuk';
    case 'Nature':
      return 'tree';
    case 'Night Activities':
      return 'night';
    case 'Seasonal Activities':
      return 'weather';
    case 'Shopping':
      return 'shopping';
    case 'Smart Casual':
      return 'shirt';
    case 'Volunteering & Social Impact':
      return 'volunteer';
    case 'Physical Strength':
      return 'muscle';
    case 'Physical Strength Required':
      return 'muscle';
    case 'Vegetarian':
      return 'vegetable';
    case 'Vegetarian Food Available':
      return 'vegetable';

    default: return type;
  }
};

export const mapMeetingPointToDetail = type => {
  switch (type) {
    case 'hotel':
      return 'Hotel Pickup';
    case 'airplane':
      return 'Airport';
    case 'arl':
      return 'Airport Rail Link Station';
    case 'bts':
      return 'BTS Station';
    case 'bus':
      return 'Bus Terminal';
    case 'mrt':
      return 'MRT Station';
    case 'train':
      return 'Railway Station';
    default: return type;
  }
};

export const thaiCities = [
  'Bangkok',
  'Near Bangkok',
  'Hua Hin',
  'Amnat Charoen',
  'Ang Thong',
  'Ayutthaya',
  'Bueng Kan',
  'Buriram',
  'Chachoengsao',
  'Chainat',
  'Chaiyaphum',
  'Chanthaburi',
  'Chiang Mai',
  'Near Chiang Mai',
  'Chiang Rai',
  'Chonburi',
  'Chumphon',
  'Hat Yai',
  'Kalasin',
  'Kamphaeng Phet',
  'Kanchanaburi',
  'Khon Kaen',
  'Krabi',
  'Lampang',
  'Lamphun',
  'Loei',
  'Lopburi',
  'Mae Hong Son',
  'Maha Sarakham',
  'Mukdahan',
  'Nakhon Nayok',
  'Nakhon Pathom',
  'Nakhon Phanom',
  'Nakhon Ratchasima',
  'Nakhon Sawan',
  'Nakhon Si Thammarat',
  'Nan',
  'Narathiwat',
  'Nong Bua Lamphu',
  'Nong Khai City',
  'Nonthaburi',
  'Pathum Thani',
  'Pattani',
  'Pattaya',
  'Phang Nga',
  'Phatthalung',
  'Phayao',
  'Phetchabun',
  'Phetchaburi',
  'Phichit',
  'Phitsanulok',
  'Phrae',
  'Phuket',
  'Prachinburi',
  'Prachuap Khiri Khan',
  'Ranong',
  'Ratchaburi',
  'Rayong',
  'Roi Et',
  'Sa Kaeo',
  'Sakon Nakhon',
  'Samut Prakan',
  'Samut Sakhon',
  'Samut Songkhram',
  'Saraburi',
  'Satun',
  'Sing Buri',
  'Sisaket',
  'Songkhla',
  'Sukhothai',
  'Suphan Buri',
  'Surat Thani',
  'Samui',
  'Surin',
  'Tak',
  'Trang',
  'Trat',
  'Ubon Ratchathani',
  'Udon Thani',
  'Uthai Thani',
  'Uttaradit',
  'Yala',
  'Yasothon'
];

export const getAdditionalOptionItem = (options = [], key = '') => {
  return options.find(o => o.key === key) || null;
};

export const isDateStatusMatch = (status, date, availabilities) => {
  let findResult;
  if (status === 'available') {
    findResult = availabilities.find(avail => (moment(avail.date).isSame(date) && avail.status === 'available'));
  } else if (status === 'replaceable') {
    findResult = availabilities.find(avail => (moment(avail.date).isSame(date) && avail.is_replaceable));
  }
  return !!findResult;
};

export const checkTierAvailability = (multiTier, date) => {
  if (!!multiTier.unavailable_dates && multiTier.unavailable_dates.length > 0) {
    return multiTier.unavailable_dates.every(data => {
      let res = true;
      if (!!data.from && !!data.to) {
        res = !moment(date).isBetween(data.from, data.to, null, '[]');
      } else if (!!data.from) {
        res = !moment(date).isSameOrAfter(data.from);
      } else if (!!data.to) {
        res = !moment(date).isSameOrBefore(data.to);
      }
      return res;
    });
  }
  return true;
};

export const mapMultiTierPricesToDisplay = (tier) => {
  return {
    ...tier,
    active: false,
    sub_tiers: tier.sub_tiers.map((subTier, subIndex) => ({
      ...subTier,
      quantity: subIndex === 0 ? 2 : 0
    }))
  };
};

export const forceProductPath = [
  '5c0fa974bc1c330011ec5e8b',
  '5d1daadec6844d00164b3c31',
  '5b7a472b84f1b20012e812d3',
  '5b83cae8b1ebf800118b568e',
  '5c111a5abc1c330011ec9633',
  '5c111b27bc1c330011ec964c',
  '5c5903fb4b13410011079516',
  '5c5917794b13410011079a4b',
  '5c59537f129f6c00132f7784',
  '5c9b49257457be0012b16184',
  '5c9b4b227457be0012b161a3',
  '5d270f670a65410017190afe',
  '5d689f1120035a0012158319',
  '5ccfbb3ae8bf8e0014d1bd78',
  '5c63e375129f6c001330f35d',
  '5e12f6550a34bc001140d149',
  '5e12e9c90a34bc001140ceec',
  '5e12f3640a34bc001140d067',
];

export const getProductUrl = trip => {
  if (forceProductPath.includes(trip._id.toString())) {
    return `/product/${trip.slug}`;
  }
  if (trip.product_type === 'ticket') {
    return `/ticket/${trip.slug}`;
  }
  if (['car_rental', 'souvenir'].includes(trip.product_type)) {
    return `/product/${trip.slug}`;
  }
  return `/trip/${trip.slug}`;
};
